module.exports = __webpack_public_path__ + "img/chat.8c7590aa.png";